/**
 * Business hours model
 */
export class BusinessHours {
  /**
   * Unique identifier for this record in the database
   */
  id: number;

  /**
   * From MM/DD
   */
  fromMmDd: string;

  /**
   * To MM/DD
   */
  toMmDd: string;

  /**
   * From weekday
   */
  fromWeekDay: string;

  /**
   * To weekday
   */
  toWeekDay: string;

  /**
   * From time (local HH:MM)
   */
  fromTime: string;

  /**
   * To time (local HH:MM)
   */
  toTime: string;

  /**
   * Date record was last updated
   */
  updateDate: Date;

  /**
   * User ID who last updated the record
   */
  updateBy: Date;

  /**
   * Parses business hours
   * @param data {any} Business hours as returned by API
   * @return {BusinessHours} Parsed business hours
   */
  static parse(data: any): BusinessHours {
    return {
      id: data.businessHoursId,
      fromMmDd: data.fromMmDd,
      toMmDd: data.toMmDd,
      fromWeekDay: data.fromWeekDay,
      toWeekDay: data.toWeekDay,
      fromTime: data.fromTime,
      toTime: data.toTime,
      updateDate: data.updateDate ? new Date(data.updateDate) : null,
      updateBy: data.updateBy
    };
  }
}
